/**
 * User: Faris
 * Date: 6/24/13
 * Time: 4:30 PM
 */

define('app/views/amenities',['require','./page','text!../../../views/amenities.html'],function(require) {

  var Page = require('./page');
  var template = require('text!../../../views/amenities.html');

  return Page.extend({

    template: _.template(template),

    initialize: function(options){
      Page.prototype.initialize.call(this, options);
    },

    onResize: function(e){
      Page.prototype.onResize.call(this, e);
    }

  });

});

